import api from "../api";

export const deleteUser = async (phone, password) => {
    try {
      const response = await api.post(process.env.REACT_APP_API_ENDPOINT + '/api/user/delete', {
        phone,
        password,
      });
      return response.data;
    } catch (error) {
      console.error('Delete failed:', error);
      throw error;
    }
  };
  